import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase, ButtonIconTrash, InputAutoresize } from "../../../common/components/form";
// import BackNext from "./BackNext.jsx";
import InputMenuLinkTitle from "./InputMenuLinkTitle.jsx";

// import WizardCheck from "./WizardCheck";
// const { MultipleCheck } = WizardCheck;

const FEATURES_MIN = 2;
const FEATURES_MAX = null;

export default function WStep5Features(props) {
    const { t } = useTranslation();

    const { set, isCustom, variables, variables2block } = props;

    const items = isCustom ? [variables2block] : [{ variables }];

    return (
        <div className="wizard-part-inner">
            <div style={{ flex: 1 }}>
                <h1>{t("WizardWStep5Header")}</h1>

                {items.map((item, index) => (
                    <Item key={index} {...item} set={(...args) => set(...args, item)} />
                ))}
            </div>
        </div>
    );
}

function Item(props) {
    const { t } = useTranslation();

    const {
        set,
        variables: { Features },
    } = props;

    const _Features = Features ?? new Array(FEATURES_MIN).fill(null).map(_ => ({}));

    function onItemChange({ name, value }, item) {
        for (const _item of _Features) {
            if (_item === item) {
                _item[name] = value;
                break;
            }
        }

        set({ Features: _Features });
    }

    function onItemRemove(item) {
        set({ Features: _Features.filter(a => a !== item) });
    }

    function onAddItemClick() {
        _Features.push({});
        set({ Features: _Features });
    }

    // const allowNext = MultipleCheck({ Features });
    return (
        <>
            <div className="margin-top-40">
                <InputMenuLinkTitle name="Features" {...props} />
            </div>

            <div className="margin-top-40">
                <p>{t("WizardWStep5Text1")}</p>
                <p>{t("WizardWStep5Text2")}</p>
            </div>

            <div className="margin-top-40 grid-gap-40 grid-center">
                {_Features.map((item, index) => (
                    <div key={index} className="flex-gap-20 flex-center relative">
                        <div className="grid-gap-20 wizard-features" style={{ width: "320px" }}>
                            <InputAutoresize
                                className="full-width"
                                name="header"
                                onChange={({ target: { name, value } }) => onItemChange({ name, value }, item)}
                                value={item.header || ""}
                                placeholder={t("WizardWStep5FeatureHeaderInputPlaceholder")}
                            />

                            <InputAutoresize
                                className="full-width"
                                name="text"
                                onChange={({ target: { name, value } }) => onItemChange({ name, value }, item)}
                                value={item.text || ""}
                                placeholder={t("WizardWStep5FeatureTextInputPlaceholder")}
                                rows="3"
                            />

                            <div className="absolute" style={{ left: "calc(100% + 20px)" }}>
                                <ButtonIconTrash
                                    noMargin
                                    disabled={_Features.length <= FEATURES_MIN}
                                    onClick={() => onItemRemove(item)}
                                />
                            </div>
                        </div>
                    </div>
                ))}

                <div>
                    <ButtonBase
                        dashed
                        onClick={onAddItemClick}
                        disabled={FEATURES_MAX && _Features.length >= FEATURES_MAX}
                    >
                        {t("PlusAdd")}
                    </ButtonBase>
                </div>
            </div>
        </>
    );
}
